import React from 'react';
import type { ThemePalette } from '../../theme/tokens';
import { Ball } from './Ball';

export interface NumberRowProps {
  main?: number[];
  bonus?: number[];
  matchedMain?: number[];
  matchedBonus?: number[];
  size?: number;
  c: ThemePalette;
  gap?: number;
  style?: React.CSSProperties;
}

export const NumberRow: React.FC<NumberRowProps> = ({
  main = [],
  bonus = [],
  matchedMain = [],
  matchedBonus = [],
  size = 40,
  c,
  gap = 8,
  style = {},
}) => {
  const matchedMainSet = new Set(matchedMain);
  const matchedBonusSet = new Set(matchedBonus);
  return (
    <div className="flex items-center" style={{ gap, ...style }}>
      {main.map((n, i) => (
        <Ball key={`m${i}`} n={n} size={size} c={c} matched={matchedMainSet.has(n)} />
      ))}
      {bonus.length > 0 && (
        <>
          <div
            style={{
              width: 1,
              height: size * 0.6,
              background: c.line,
              margin: `0 ${gap / 2}px`,
            }}
          />
          {bonus.map((n, i) => (
            <Ball key={`b${i}`} n={n} size={size} lucky c={c} matched={matchedBonusSet.has(n)} />
          ))}
        </>
      )}
    </div>
  );
};
